import React, { useState } from "react";

const ModificationCommentModal = ({
  isOpen,
  onClose,
  handleSave,
  documentData,
  documentType,
  COMPANY_CODE,
  DEPARTMENT,
  CURRENT_USER,
  BASE_URL,
}) => {
  const [comment, setComment] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setErrorMessage("");
    onClose();
  };

  const getDocType = () => {
    return documentType === "SALESINVOICE"
      ? "SALESINVOICE"
      : documentType === "QUOTATION"
      ? "QUOTATION"
      : documentType === "SALESRETURN"
      ? "SALESRETURN"
      : documentType === "PURCHASEINVOICE"
      ? "PINV"
      : documentType === "PURCHASEORDER"
      ? "PORD"
      : documentType === "WORKORDER"
      ? "WO"
      : documentType === "SAMPLEISSUE"
      ? "DEMOISSUE"
      : documentType === "SAMPLERETURN"
      ? "DEMORETURN"
      : "DELIVERYORDER";
  };

  const isValidComment = (text) => {
    const trimmed = text.trim();
    if (!trimmed || trimmed === "." || trimmed.length < 2) {
      return false;
    }
    return true;
  };

  const handleSaveWithComment = async () => {
    if (!isValidComment(comment)) {
      setErrorMessage(
        "Comment must be meaningful and at least 2 characters long, not just spaces or a dot."
      );
      return;
    }

    setIsSaving(true);
    setErrorMessage("");

    try {
      const commentPayload = [
        {
          cmpcode: COMPANY_CODE,
          doc_no: documentData.documentNo || "",
          status: "modified",
          evaluationcomments: comment.trim(),
          userid: CURRENT_USER,
          deptno: DEPARTMENT,
          doctype: getDocType(),
        },
      ];

      const commentResponse = await fetch(`${BASE_URL}/api/CRMDocLogReg`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(commentPayload),
      });

      if (!commentResponse.ok) {
        throw new Error("Failed to save modification comment");
      }

      await handleSave();
      setComment("");
    } catch (error) {
      console.error("Error saving modification comment:", error);
      alert("Failed to save modification comment. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="p-6">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Modification Comment <span className="text-red-500">*</span>
        </label>
        <textarea
          value={comment}
          onChange={(e) => {
            setComment(e.target.value);
            if (errorMessage) setErrorMessage("");
          }}
          placeholder="Enter modification details..."
          rows={6}
          autoFocus
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${
            errorMessage ? "border-red-500" : "border-gray-300"
          }`}
          disabled={isSaving}
        />

        <p className="mt-1 text-xs text-gray-500">
          Describe what changes were made in this update
        </p>
        {errorMessage && (
          <p className="mt-1 text-xs text-red-600 font-semibold">
            {errorMessage}
          </p>
        )}
      </div>

      <div className="flex items-center justify-end gap-3 mt-6">
        <button
          onClick={handleClose}
          disabled={isSaving}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
        <button
          onClick={handleSaveWithComment}
          disabled={isSaving}
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          {isSaving ? (
            <>
              <svg
                className="animate-spin h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Saving...
            </>
          ) : (
            "Save Changes"
          )}
        </button>
      </div>
    </div>
  );
};

export default ModificationCommentModal;
